class CartDrawer {
  constructor(root) {
    this.root = root
    this.dialog = root.querySelector("dialog")
    this.overlay = root.querySelector("[data-close]")
    this.closeBtns = root.querySelectorAll("[data-close]")
    this.itemsEl = root.querySelector("[data-items]")
    this.summaryEl = root.querySelector("[data-summary]")
    this.progressEl = root.querySelector(".cart-drawer__progress")
    this.closeButton = root.querySelector('[data-close-cart-drawer="true"]')
    this.progressBar = root.querySelector('[data-cart-drawer-progress-bar="true"]')

    this.closeButton?.addEventListener("click", this.close.bind(this))
    this.dialog?.addEventListener("click", (e) => {
      const rect = this.dialog.getBoundingClientRect()
      if (e.clientX < rect.left || e.clientX > rect.right || e.clientY < rect.top || e.clientY > rect.bottom) {
        this.close()
      }
    })

    this.bind()
  }

  bind() {
    document.addEventListener("click", (e) => {
      const t = e.target

      if (t.closest("[data-cart-open]")) {
        e.preventDefault()
        this.open()
        return
      }

      // Remove line
      const removeKey = t.closest("[data-remove]")?.getAttribute("data-remove")
      if (removeKey) {
        e.preventDefault()
        this.update({ updates: { [removeKey]: 0 } })
        return
      }

      // Qty controls
      if (t.matches("[data-increment], [data-decrement]")) {
        const wrap = t.closest("[data-qty]")
        const input = wrap.querySelector("input")
        let next = Number.parseInt(input.value || "1", 10)
        next = t.hasAttribute("data-increment") ? next + 1 : Math.max(0, next - 1)
        const key = input.name.match(/\[(.+)\]/)[1]
        this.update({ updates: { [key]: next } })
        return
      }

      // Close - handle data-close attribute and clicking backdrop
      if (t.hasAttribute("data-close") || t === this.dialog) {
        this.close()
      }
    })

    document.addEventListener("cart:update", async (e) => {
      // Always refresh the cart to show updated contents first
      await this.refresh()

      // Only auto-open if the event is from adding items (not errors or removals)
      if (!e.detail?.data?.didError) {
        this.open()
      }
    })
  }

  async update(body) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      credentials: "same-origin",
      cache: "no-store",
      body: JSON.stringify(body),
    })
    await this.refresh()
  }

  async refresh() {
    const sectionId = this.root.dataset.sectionId
    if (!sectionId) return

    // Fetch the header section from the CURRENT page context (not /cart)
    const base = window.location.pathname || "/"
    const url = `${base}?section_id=${encodeURIComponent(sectionId)}&_=${Date.now()}`

    const res = await fetch(url, {
      headers: { "X-Requested-With": "XMLHttpRequest" },
      credentials: "same-origin",
      cache: "no-store",
    })

    const html = await res.text()
    const dom = new DOMParser().parseFromString(html, "text/html")

    // Grab the updated cart drawer markup returned by Shopify section rendering
    const nextDrawer = dom.querySelector("#cart-drawer")
    if (!nextDrawer) {
      // If section render didn't include drawer, bail safely
      return
    }

    const nextItemsComponent = nextDrawer.querySelector("cart-items-component")
    const currentItemsComponent = this.root.querySelector("cart-items-component")

    if (nextItemsComponent && currentItemsComponent) {
      // KEY FIX: replace the whole inner markup so empty -> items can change
      currentItemsComponent.innerHTML = nextItemsComponent.innerHTML
    }

    // Also sync empty-state class on the dialog (your Liquid toggles cart-drawer--empty)
    const nextDialog = nextDrawer.querySelector("dialog.cart-drawer__dialog")
    const currentDialog = this.root.querySelector("dialog.cart-drawer__dialog")

    if (nextDialog && currentDialog) {
      // copy className so cart-drawer--empty toggles correctly
      currentDialog.className = nextDialog.className
    }

    this.updateProgress()
  }



  open() {
    this.root.hidden = false
    this.root.setAttribute("aria-hidden", "false")

    if (this.dialog && !this.dialog.open) {
      this.dialog.showModal()
    }

    requestAnimationFrame(() => {
      this.root.classList.add("is-open")
      document.documentElement.style.overflow = "hidden"
    })

    this.updateProgress()
  }

  close() {
    this.root.classList.remove("is-open")
    this.root.setAttribute("aria-hidden", "true")

    if (this.dialog && this.dialog.open) {
      this.dialog.close()
    }

    document.documentElement.style.overflow = ""

    setTimeout(() => {
      this.root.hidden = true
    }, 250)
  }

  async updateProgress() {
    if (!this.progressEl) return
    const cart = await fetch("/cart.js", { credentials: "same-origin", cache: "no-store" }).then((r) => r.json())
    const threshold = Number.parseInt(this.progressEl.getAttribute("data-free-threshold") || "0", 10) * 100
    if (!threshold) return
    const spent = cart.total_price
    const bar = this.root.querySelector(".cart-drawer__progress-bar span")
    const txt = this.root.querySelector(".cart-drawer__progress-text")
    const pct = Math.max(0, Math.min(100, Math.round((spent / threshold) * 100)))
    if (bar) bar.style.width = pct + "%"
    if (!txt) return

    if (spent < threshold) {
      const remain = (threshold - spent) / 100
      txt.textContent = `Spend AU$${remain.toFixed(2)} more for free express delivery.`
    } else {
      txt.textContent = `Free express delivery unlocked.`
    }
  }
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initCartDrawer)
} else {
  initCartDrawer()
}

function initCartDrawer() {
  const root = document.getElementById("cart-drawer")
  if (root) {
    window.cartDrawer = new CartDrawer(root)
  }
}
